<template>
  <div class="fashion-card col-md-6 mb-3">
    <div class="fashion-image">
      <img :src="`${data.img}`" alt="" />
    </div>
    <div class="fashion-description">
      <div class="fashion-description-title">
        {{ data.title || '' }}
      </div>
      <div class="fashion-description-desc">
        {{ data.desc || '' }}
      </div>
      <div class="fashion-description-detail">
        <ul>
          <li>Fabric : {{ data.fabric || '' }}</li>
          <li>Warna : {{ data.warna || '' }}</li>
          <li>Size : {{ data.size || '' }}</li>
          <li>Brand : {{ data.brand || '' }}</li>
        </ul>
      </div>
      <div class="fashion-description-button">
        <a
          href="javascript:void(0)"
          @click="setFashion()"
          type="button"
          class="btn btn-cta mt-1"
        >
          Pilih Model
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: ['data'],
  methods: {
    ...mapActions('transactions', ['setFashionProgram']),
    setFashion() {
      const program = {
        fashionId: this.data.id,
        fashionTitle: this.data.title,
      };

      this.setFashionProgram(program);

      this.$router.push({ name: 'danai-baju-baru' });
    },
  },
};
</script>

<style lang="scss" scoped>
.fashion-card {
  display: flex;

  .fashion-image {
    flex-grow: 0;
    width: 168px;
    height: 367px;
  }

  .fashion-description {
    flex-grow: 1;
    padding: 0px 15px 0px 15px;
    flex-basis: 25em;

    @media screen and (max-width: 480px) {
      font-size: 14px;
    }

    .fashion-description-title {
      font-weight: bold;

      @media screen and (min-width: 481px) and (max-width: 769px) {
        min-height: 50px;
      }
    }

    .fashion-description-desc {
      min-height: 120px;

      @media screen and (min-width: 481px) and (max-width: 768px),
        (min-width: 769px) and (max-width: 1024px) {
        min-height: 150px;
      }
    }

    .fashion-description-title,
    .fashion-description-desc,
    .fashion-description-detail {
      margin-bottom: 10px !important;

      @media screen and (max-width: 480px) {
        margin-bottom: 10px !important;
      }
      @media screen and (min-width: 481px) and (max-width: 769px) {
        margin-bottom: 0px !important;
      }
    }

    ul {
      list-style-type: none;
      margin: 0px;
      padding: 0px;
      li {
        margin-bottom: 8px;

        @media screen and (max-width: 480px) {
          margin-bottom: 2px;
        }
      }
    }
  }
}
</style>
